import React, { useState, useEffect } from 'react';

//imports projeto
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import ModalDeleteBatchToCar from "components/ModalDeleteBatchToCar/ModalDeleteBatchToCar";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import { formatDate } from "services/formatDate.js";

//imports Material MUI
import Close from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    acctAll: {
        float: "right",
        marginTop: "-29px"
    },
    floatRight: {
        float: "right",
        marginRight: "56px"
    }
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

function TableBatch({ batchToCar, loadBatchToCar }) {


    const classes = useStyles();
    const classes2 = useStyles2();
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [index, setIndex] = useState(batchToCar[0] ? batchToCar[0] : { id: 1 });
    const [total, setTotal] = useState(0);

    function callModalDelete(index) {
        setIndex(index);
        setModalShowDelete(true);
    }

    function totalPrice(index) {
        let totalWeight = 0;
        for (let i = 0; i < index.length; i++) {
            totalWeight = totalWeight + parseFloat(index[i].weight)
        }
        setTotal(totalWeight);
    }

    useEffect(() => {
        totalPrice(batchToCar)
    }, [batchToCar])

    function getBatchs() {

        let teste = [];
        for (let i = 0; i < batchToCar.length; i++) {
            teste[i] = [];
            teste[i].push(batchToCar[i].batch)
            teste[i].push(batchToCar[i].name_car_batch);
            teste[i].push(batchToCar[i].plate);
            teste[i].push(batchToCar[i].capacity_car + "Kg");
            teste[i].push(batchToCar[i].deliverymanname);
            teste[i].push(formatDate(batchToCar[i].created_at));
            teste[i].push(
                <div className={classes2.tableActions}>
                    {/* <Tooltip
                        id="tooltip-top"
                        title="Editar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Edit"
                            className={classes2.tableActionButton}
                            onClick={() => callModal(batchToCar[i])}

                        >
                            <Edit
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.edit
                                }
                            />
                        </IconButton>

                    </Tooltip>
                     */}
                    <Tooltip
                        id="tooltip-top-start"
                        title="Deletar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Close"
                            className={classes2.tableActionButton}
                            onClick={() => callModalDelete(batchToCar[i])}
                        >
                            <Close
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.close
                                }
                            />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        }

        return teste;
    }


    return (
        <GridItem xs={12} sm={12} md={12}>
            {batchToCar[0] !== undefined ? (
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader className={classes.zindex} color={"primary"}>
                            <h4 className={classes.cardTitleWhite}>Divisão de carga por lotes - {batchToCar[0].batch_to_car_controller} - {total.toFixed(2) + "kg"}</h4>
                            <p className={classes.cardCategoryWhite}></p>
                        </CardHeader>
                        <CardBody>
                            <Table
                                index={index}
                                tableHeaderColor="primary"
                                tableHead={["Lote", "Nome do carro", "Placa", "Capacidade", "Entregador", "Data de criaçao", "Ações"]}
                                tableData={getBatchs()}
                            />
                        </CardBody>
                    </Card>
                    {/*<ModalUpdateBatchToCar key={String("upd_" + index.id)} props={index} loadBatchToCar={loadBatchToCar} show={modalShow}
                        onHide={() => setModalShow(false)} />
                        */}
                    <ModalDeleteBatchToCar key={String("del_" + index.id)} props={index} loadBatchToCar={loadBatchToCar} show={modalShowDelete}
                        onHide={() => setModalShowDelete(false)} />
                </GridItem >
            ) : <div></div>}
        </GridItem>
    );
}

export default TableBatch;